import { AppHelper } from "../../appHelper";
import { StringKeyDictionary } from "../../commonInterfaces";
import { Entity } from "../../core/components/commonApp";
import { Grid } from "../../core/components/grid";
import { GridCustomToolBarButton } from "../../core/components/toolBar";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import ExecutionsGridApp from "./executionsGrid";
import { AssignmentInfoItem, ExecutionState } from "./recurringTaskHistory";
import React from "react"
export default class AssignmentsGridApp extends React.Component<AssignmentsGridAppProps, AssignmentsAppState>
{
    assignmentGridOptions: {};
    common = new AppHelper();
    translations: StringKeyDictionary<string> = null;

    constructor(props) {
        super(props);
        this.common.init(this);
        this.state = {
            selectedAssignment: null,
            assignmentsGridData: [],
            filterAssignments: false
        }
        this.assignmentGridOptions = this.props.context.assignmentGridOptions;
    }

    handleClickCustomButtonAssignmentsGrid = (id: string) => {
        if (id === "deleteAssignment") {
            this.deleteAssignment(this.state.selectedAssignment);
        }
        if (id === "showAll") {
            this.setState({ filterAssignments: false });
        }
    }

    public deleteAssignment = (node: AssignmentInfoItem) => {
        this.dialogQuestion(Helper.getTranslation("Standard.Msg.Loeschen"), async () => {
            let result = await HTTPService.post<JsonResultClass<boolean>>('ResourcePlanning/DeleteAssignment?projNr=' + encodeURIComponent(node.ProjectNo) + '&pIndex=' + node.Pindex);
            if (result.Code === 0) {
                this.props.executionsGridRef.getAndRefreshExecution(node.ExecutionId);
            } else {
                NotificationHelper.showErrorResult(result);
            }
        });
    }

    private dialogQuestion = async (question: string, action) => {
        const isOk = await DialogHelper.confirm(question);
        if (isOk)
            action();
    }

    componentDidMount() {
        this.props.onLoaded();
    }

    render() {
        var gridData = [];
        var filterMessage = null;
        const labelStyle: React.CSSProperties = {
            backgroundColor: "#fff19d",
            color: "#6a5b00"
        }
        if (Helper.hasValue(this.props.executionsGridRef)) {
            gridData = this.props.executionsGridRef.getAssignmentGridData(this.state.filterAssignments);
            filterMessage = <label style={labelStyle}>{this.props.executionsGridRef.getFilterMessage(this.state.filterAssignments)}</label>;
        }    

        const customButtons: Array<GridCustomToolBarButton> = [];

        customButtons.push({
            id: "showAll", enabled: this.state.filterAssignments, caption: Helper.getTranslation("Standard.Alle"), iconClass: "k-i-refresh", autoEnabledOnRecordSelected: false
        });

        const showDeleteAssignment = this.state.selectedAssignment != null && this.state.selectedAssignment.ParentExecutionState != null &&
            this.state.selectedAssignment.ParentExecutionState.Value != ExecutionState.Finished && this.state.selectedAssignment.ParentExecutionState.Value != ExecutionState.Cancelled;
        customButtons.push({
            id: "deleteAssignment", enabled: showDeleteAssignment, caption: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.DeleteAssignment"), iconClass: "fas fa-trash", autoEnabledOnRecordSelected: false
        });

        const content = <div style={{ height: "400px" }}> <Grid data={gridData} options={this.assignmentGridOptions} id="executedTasksGrid"
            onSelectionChanged={(dataItem: AssignmentInfoItem) => { this.setState({ selectedAssignment: dataItem }) }}
            customButtons={customButtons} onClickCustomButton={this.handleClickCustomButtonAssignmentsGrid}
        />
        </div>

        return (<>
            {filterMessage}
            {content}
        </>);
    }
}

export interface AssignmentsGridAppProps {
    entity: Entity;
    context: {
        assignmentGridOptions?: {};
    };
    executionsGridRef?: ExecutionsGridApp;
    onLoaded: () => void;
}

export interface AssignmentsAppState {
    selectedAssignment: AssignmentInfoItem;
    assignmentsGridData: AssignmentInfoItem[];
    filterAssignments: boolean;
}